import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { useModal } from "@Contexts/ModalContext";

import Button from "@UI/kit/Button/Button";
import Loader from "@UI/kit/Loader/Loader";

import { ReactComponent as CircleCheckFilled } from "@Icons/payments/CircleCheckFilled.svg";

const PaymentPendingModal = () => {
  const { content, closeModal } = useModal();
  const { statusUrl, plateNumber, parkingUid } = content;
  const { t } = useTranslation();
  const [isTimeout, setIsTimeout] = useState(false);

  useEffect(() => {
    let pollInterval;
    let timeoutId;

    const checkStatus = async () => {
      try {
        const { data } = await axios.get(statusUrl);
        const { status } = data;

        if (status === "SUCCESS") {
          clearInterval(pollInterval);
          clearTimeout(timeoutId);
          closeModal();
          window.location.href = `${process.env.REACT_APP_BASE_URL}/payment-success/${parkingUid}/${plateNumber}`;
        } else if (status === "FAILED") {
          clearInterval(pollInterval);
          clearTimeout(timeoutId);
          closeModal();
          window.location.href = `${process.env.REACT_APP_BASE_URL}/payment-error`;
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    };

    // Polling каждые 3 секунды
    pollInterval = setInterval(checkStatus, 3000);

    // Timeout через 60 секунд
    timeoutId = setTimeout(() => {
      clearInterval(pollInterval);
      setIsTimeout(true);
      setTimeout(() => {
        closeModal();
        window.location.href = `${process.env.REACT_APP_BASE_URL}/payment-error`;
      }, 2000);
    }, 60000);

    // Первая проверка сразу
    checkStatus();

    return () => {
      clearInterval(pollInterval);
      clearTimeout(timeoutId);
    };
  }, [statusUrl, plateNumber, parkingUid, closeModal]);

  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-modal">
      <div
        className="relative flex h-[90vh] w-full max-w-[640px] flex-col items-center justify-center space-y-6 rounded-none bg-white p-4 shadow-modal xs:h-auto xs:w-[85%] xs:rounded-xl lg:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Иконка с анимацией пульсации */}
        <div className="animate-pulse">
          <CircleCheckFilled className="text-btnBlue h-16 w-16 sm:h-20 sm:w-20" />
        </div>

        {/* Заголовок */}
        <p className="text-center text-xl font-semibold text-textNormal sm:text-2xl">{t("payment_in_progress")}</p>

        {/* Описание */}
        <p className="max-w-[280px] text-center text-sm text-textMuted sm:max-w-[360px] sm:text-base">
          {isTimeout ? t("payment_timeout") : t("check_your_phone")}
        </p>

        {/* Loader */}
        {!isTimeout && <Loader />}

        {/* Подсказка */}
        {!isTimeout && <p className="text-xs text-textGray sm:text-sm">{t("waiting_for_payment_confirmation")}</p>}

        {/* Кнопка отмены */}
        <Button
          text={t("cancel")}
          onClick={() => {
            closeModal();
            window.location.href = `${process.env.REACT_APP_BASE_URL}/parking/${parkingUid}/info/payment/${plateNumber}/MPESA`;
          }}
          // styles="bg-white text-btnBlue border-2 border-btnBlue hover:bg-gray-50"
        />
      </div>
    </div>
  );
};

export default PaymentPendingModal;
